import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Popover } from '@tribeplatform/react-ui-kit/Popover';
import { ImagePickerTabs } from './ImagePicker';
export const PopoverImagePicker = ({ children, ...rest }) => {
    const [active, setActive] = useState(false);
    const toggleActive = useCallback(() => setActive(active => !active), []);
    const onClose = useCallback(() => setActive(false), []);
    const activator = _jsx("div", { onClick: toggleActive, children: children }, void 0);
    return (_jsx(Popover, { activator: activator, open: active, onClose: onClose, autofocusTarget: "first-node", fluidContent: true, children: _jsx(ImagePickerTabs, { onSelect: onClose, ...rest }, void 0) }, void 0));
};
//# sourceMappingURL=PopoverImagePicker.js.map